import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Button, Modal, ModalHeader, ModalBody, ModalFooter, Container, Input } from "reactstrap";
import { Link } from "react-router-dom";
import { useUser } from '../components/Context/UserContext';
import profileImg from "../assets/logo.png";
import "../styles/VendorsList.css";

const ViewAllVendors = () => {
    const [vendors, setVendors] = useState([]);
    const [sortBy, setSortBy] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [isEditing, setIsEditing] = useState(false);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [activeTab, setActiveTab] = useState("history");
    const [subTab, setSubTab] = useState("details");
    const vendorsPerPage = 6;
    const [showModal, setShowModal] = useState(false);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [showCard, setShowCard] = useState(false);
    const { user } = useUser();

    useEffect(() => {
        axios.get("/api/vendordetails/details")
            .then(res => {
                console.log("Fetched vendors:", res.data); // Add this
                setVendors(res.data);
            })
            .catch(err => console.error("Error fetching vendors:", err));
    }, []);

    useEffect(() => {
        const dark = localStorage.getItem("darkMode") === "true";
        document.body.classList.toggle("dark-mode", dark);
    }, []);

    
    const handleReviewClick = (index) => {
        setSelectedVendor({ ...vendors[index], index });
        setShowModal(true);
        setIsEditing(false);
    };
    const handleInputChange = (e, field) => {
        setSelectedVendor({ ...selectedVendor, [field]: e.target.value });
    };

    const totalPages = Math.ceil(vendors.length / vendorsPerPage);
    const startIndex = (currentPage - 1) * vendorsPerPage;
    const vendorsForPage = vendors.slice(startIndex, startIndex + vendorsPerPage);

    const handlePageChange = (type) => {
        if (type === "first") setCurrentPage(1);
        if (type === "prev" && currentPage > 1) setCurrentPage(currentPage - 1);
        if (type === "next" && currentPage < totalPages) setCurrentPage(currentPage + 1);
        if (type === "last") setCurrentPage(totalPages);
    };
    const handleSave = () => {
        if (selectedVendor && selectedVendor.index !== undefined) {
            const updatedVendors = [...vendors];
            updatedVendors[selectedVendor.index] = { ...selectedVendor };
            delete updatedVendors[selectedVendor.index].index;
            setVendors(updatedVendors);
        }
        setIsEditing(false);
        setShowModal(false);
    };

    const handleApprove = () => {
        if (selectedVendor && selectedVendor.index !== undefined) {
            const updatedVendors = [...vendors];
            updatedVendors[selectedVendor.index].approvalStatus = "Approved";
            setVendors(updatedVendors);
        }
        setShowModal(false);
    };

    const handleReject = () => {
        if (selectedVendor && selectedVendor.index !== undefined) {
            const updatedVendors = [...vendors];
            updatedVendors[selectedVendor.index].approvalStatus = "Rejected";
            setVendors(updatedVendors);
        }
        setShowModal(false);
    };


    const handleViewDetails = (index) => {
        setSelectedVendor({ ...vendors[index] });
        setShowModal(true);
    };

    return (
        <div className="view-vendors-container">
            <div className="navbar">
                <div className="navbar-left">
                    <button className="toggle-btn" onClick={() => setSidebarOpen(!sidebarOpen)}>&#9776;</button>
                </div>
                <div className="navbar-right">
                    <Link to="/">Home</Link>
                    <Link to="/master-page">Dashboard</Link>
                    <img src={profileImg} className="profile-img" onClick={() => setShowCard(!showCard)} alt="User" />
                </div>
            </div>

            <div className="main-layout">
                <div className={`sidebar ${sidebarOpen ? "open" : "closed"}`}>
                    <ul>
                        <li><Link to="/Vendors">Vendors</Link></li>
                        <li><Link to="/ViewAllUsers">View All Users</Link></li>
                        <li><Link to="/ViewAllVendors">View All Vendors</Link></li>
                        <li><Link to="/ViewAllInvoice">View All Invoice</Link></li>
                        <li><Link to="/VendorsList">Vendors List</Link></li>
                    </ul>
                </div>

                <div className={`content ${sidebarOpen ? "shifted" : ""}`}>
                    <Container>
                        <h2 className="page-title">Vendors List</h2>
                        <div className="table-responsive">
                            <Table striped bordered hover className="vendors-table">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Nature of Supply </th>
                                        <th>PAN </th>
                                        <th>GST </th>
                                        <th>IFSC Code </th>
                                        <th>Legal Name </th>
                                        <th>City </th>
                                        <th>State </th>
                                        <th>Country </th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {vendorsForPage.map((vendor, index) => (
                                        <tr key={vendor.id || index}>
                                            <td>{startIndex + index + 1}</td>
                                            <td>{vendor.natureOfSupply || "N/A"}</td>
                                            <td>{vendor.pan || "N/A"}</td>
                                            <td>{vendor.gst || "N/A"}</td>
                                            <td>{vendor.ifscCode || "N/A"}</td>
                                            <td>{vendor.legalName || "N/A"}</td>
                                            <td>{vendor.city || "N/A"}</td>
                                            <td>{vendor.state || "N/A"}</td>
                                            <td>{vendor.country || "N/A"}</td>
                                            
                                            <td>
                                                <button className="review-btn" onClick={() => handleReviewClick(startIndex + index)}>
                                                    Review
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>

                        {/* Pagination */}
                        <div className="pagination">
                            <button onClick={() => handlePageChange("first")} disabled={currentPage === 1}>First</button>
                            <button onClick={() => handlePageChange("prev")} disabled={currentPage === 1}>Previous</button>
                            <span>Page {currentPage} of {totalPages}</span>
                            <button onClick={() => handlePageChange("next")} disabled={currentPage === totalPages}>Next</button>
                            <button onClick={() => handlePageChange("last")} disabled={currentPage === totalPages}>Last</button>
                        </div>
                    </Container>
                    <Modal isOpen={showModal} toggle={() => setShowModal(false)} centered className="modal-lg custom-modal">
                        <ModalHeader toggle={() => setShowModal(false)}>Vendor Details</ModalHeader>
                        <div className="tabs1">
                            <span className={activeTab === "history" ? "active-tab" : ""} onClick={() => setActiveTab("history")}>History</span>
                            <span className={activeTab === "info" ? "active-tab" : ""} onClick={() => setActiveTab("info")}>Info</span>
                            <span className={activeTab === "details" ? "active-tab" : ""} onClick={() => setActiveTab("details")}>Info Details</span>

                        </div>
                        <ModalBody>
                            {activeTab === "history" && selectedVendor && (

                                <div className="history-container">
                                    <h5>Profile Update History</h5>
                                    <Table bordered className="history-table">
                                        <thead>
                                            <tr>
                                                <th>Date & Time</th>
                                                <th>Field Changed</th>
                                                <th>Previous Value</th>
                                                <th>Updated Value</th>
                                                <th>Updated By</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>2025-03-30 12:30 PM</td>
                                                <td>PAN Number</td>
                                                <td>ABCDE1234F</td>
                                                <td>ABCDE5678X</td>
                                                <td>Admin</td>
                                            </tr>
                                        </tbody>
                                    </Table>


                                </div>
                            )}

                            {activeTab === "info" && selectedVendor && (
                                <>
                                    <div className="tabs2">
                                        <span className={subTab === "details" ? "active-tab" : ""} onClick={() => setSubTab("details")}>
                                            Details
                                        </span>
                                        <span className={subTab === "other" ? "active-tab" : ""} onClick={() => setSubTab("other")}>
                                            Other Details
                                        </span>
                                    </div>

                                    <div className="info-container">
                                        {subTab === "details" && (
                                            <>
                                                <h5>Company Information</h5>
                                                <Table bordered className="info-table">
                                                    <tbody>
                                                        <tr>
                                                            <td><strong>Company Name</strong></td>
                                                            <td>{isEditing ? <Input type="text" value={selectedVendor.legalName} onChange={(e) => handleInputChange(e, "legalName")} /> : selectedVendor.legalName}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Contact Person</strong></td>
                                                            <td>{isEditing ? <Input type="text" value={selectedVendor.contactPersonName} onChange={(e) => handleInputChange(e, "contactPersonName")} /> : selectedVendor.contactPersonName}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>Nature of Supply</strong></td>
                                                            <td>{isEditing ? <Input type="select" value={selectedVendor.natureOfSupply} onChange={(e) => handleInputChange(e, "natureOfSupply")} /> : selectedVendor.natureOfSupply}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </>
                                        )}

                                        {subTab === "other" && (
                                            <>
                                                <h5>Legal & Tax Information</h5>
                                                <Table bordered className="info-table">
                                                    <tbody>
                                                        <tr>
                                                            <td><strong>MSME</strong></td>
                                                            <td>{isEditing ? <Input type="text" value={selectedVendor.msmeNo} onChange={(e) => handleInputChange(e, "msmeNo")} /> : selectedVendor.msmeNo}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>PAN Number</strong></td>
                                                            <td>{isEditing ? <Input type="text" value={selectedVendor.pan} onChange={(e) => handleInputChange(e, "pan")} /> : selectedVendor.pan}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>GST Number</strong></td>
                                                            <td>{isEditing ? <Input type="text" value={selectedVendor.gst} onChange={(e) => handleInputChange(e, "gst")} /> : selectedVendor.gst}</td>
                                                        </tr>
                                                        <tr>
                                                            <td><strong>HSN/SAC Code</strong></td>
                                                            <td>{isEditing ? <Input type="text" value={selectedVendor.hsNsacCode} onChange={(e) => handleInputChange(e, "hsNsacCode")} /> : selectedVendor.hsNsacCode}</td>
                                                        </tr>
                                                    </tbody>
                                                </Table>

                                                <h5>Approval Status</h5>
                                                <Table bordered className="info-table">
                                                    <tbody>
                                                        <tr>
                                                            <td><strong>Approval Status</strong></td>
                                                            <td className={`status-${(selectedVendor.approvalStatus || '').toLowerCase()}`}>
                                                                {selectedVendor.approvalStatus}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </Table>
                                            </>
                                        )}

                                        {isEditing && (
                                            <div className="text-center mt-3">
                                                <button className="save-btn" onClick={() => setIsEditing(false)}>Save</button>
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}


                            {activeTab === "details" && selectedVendor && (
                                <div className="details-container">
                                    <h5>Compliance & Certifications</h5>
                                    <p><strong>ISO Certified:</strong> {selectedVendor.isoCertified ? "Yes" : "No"}</p>
                                    <p><strong>ISO Certification Number:</strong> {selectedVendor.isoNumber || "N/A"}</p>
                                    <p><strong>Valid Until:</strong> {selectedVendor.certificationExpiry || "N/A"}</p>
                                    <p><strong>Environmental Certifications:</strong> {selectedVendor.environmentCerts || "N/A"}</p>
                                    <p><strong>Safety Compliance:</strong> {selectedVendor.safetyCompliance || "N/A"}</p>
                                    <br></br>
                                    <h5>Vendor Performance</h5>
                                    <p><strong>Average Delivery Time:</strong> {selectedVendor.deliveryTime || "N/A"} days</p>
                                    <p><strong>Order Fulfillment Rate:</strong> {selectedVendor.fulfillmentRate || "N/A"}%</p>
                                    <p><strong>Defect Rate:</strong> {selectedVendor.defectRate || "N/A"}%</p>
                                    <p><strong>Past Penalties/Fines:</strong> {selectedVendor.pastPenalties || "None"}</p>
                                    <br></br>
                                    <h5>Payment & Credit Terms</h5>
                                    <p><strong>Preferred Payment Method:</strong> {selectedVendor.paymentMethod || "N/A"}</p>
                                    <p><strong>Credit Period:</strong> {selectedVendor.creditPeriod || "N/A"} days</p>
                                    <p><strong>Maximum Credit Limit:</strong> ₹{selectedVendor.creditLimit || "N/A"}</p>
                                    <p><strong>Past Due Payments:</strong> {selectedVendor.pastDuePayments ? "Yes" : "No"}</p>
                                    <br></br>
                                    <h5>Business Scope & Clients</h5>
                                    <p><strong>Key Clients:</strong> {selectedVendor.keyClients || "N/A"}</p>
                                    <p><strong>Business Reach:</strong> {selectedVendor.businessReach || "N/A"}</p>
                                    <p><strong>Types of Products/Services Supplied:</strong> {selectedVendor.productsSupplied || "N/A"}</p>
                                    <br></br>
                                    <h5>Additional Notes</h5>
                                    <p><strong>Remarks:</strong> {selectedVendor.notes || "None"}</p>
                                    <p><strong>Supporting Documents:</strong> <a href={selectedVendor.documentsLink || "#"}>View</a></p>
                                </div>
                            )}
                        </ModalBody>
                        <ModalFooter>
                            {isEditing ? (
                                <>
                                    <Button color="success" onClick={handleSave}>Save</Button>
                                    <Button color="secondary" onClick={() => setIsEditing(false)}>Cancel</Button>
                                </>
                            ) : (
                                <>
                                    <Button color="warning" onClick={() => setIsEditing(true)}>Edit</Button>
                                    <Button color="success" onClick={handleApprove}>Approve</Button>
                                    <Button color="danger" onClick={handleReject}>Reject</Button>
                                </>
                            )}
                            <Button color="secondary" onClick={() => setShowModal(false)}>Close</Button>
                        </ModalFooter>
                    </Modal>
                </div>
            </div>
            {showCard && user && (
                <div className="user-card">
                    <p><strong>Name:</strong></p>
                    <input type="text" value={user.nameOfCompany} readOnly className="user-info-input" />
                    <p><strong>Email:</strong></p>
                    <input type="text" value={user.emailId} readOnly className="user-info-input" />
                    <p><Link to="/login" className="text-decoration-none">Log out</Link></p>
                </div>
            )}
        </div>
    );
};

export default ViewAllVendors;
